import { useTimeRangesForLocation } from 'custom_hooks/data_hooks/time_ranges/useTimeRangesForLocation';
import { isWorkbenchTimeRangeValid } from 'pages/workbench/shared';
import { useWorkbenchValues } from 'pages/workbench/state';
import { useEffect } from 'react';

export type UseDefaultTimeRange = Readonly<{
    locationId: string;
}>;

/**
 * @returns a boolean, true if the timeRanges are still loading
 */
export function useDefaultTimeRange({ locationId }: UseDefaultTimeRange): boolean {
    const { range, timeRange, isInitialized, setTimeRange } = useWorkbenchValues(
        (state) => ({
            range: state.range,
            timeRange: state.timeRange,
            isInitialized: state.isInitialized,
            setTimeRange: state.setTimeRange,
        }),
    );

    const { data: timeRanges, isLoading } = useTimeRangesForLocation(locationId);

    useEffect(() => {
        if (
            isInitialized &&
            timeRanges &&
            timeRanges.length > 0 &&
            (!timeRange || !range || !isWorkbenchTimeRangeValid(timeRange, timeRanges))
        ) {
            setTimeRange({
                type: 'system',
                id: timeRanges[0].Id,
                timeInSeconds: timeRanges[0].TimeInSeconds,
            });
        }
    }, [range, timeRange, isInitialized, timeRanges, setTimeRange]);

    return isLoading;
}
